import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

//- Material UI / Style
import { withStyles } from '@material-ui/core/styles';
//containers
import AuthUserContainer from '../../containers/AuthUser';
import JourneyPlanContainer from '../../containers/JourneyPlan';
//- UI / Form
import { Grid } from '@material-ui/core';
import FormActions from '../../components/form/FormActions';
import FormFileUploader from '../../components/form/FormFileUploader';
import FormSelect from '../../components/form/FormSelect';
import FormText from '../../components/form/FormText';
import FormComponent from '../../components/FormComponent';
import FormContainer from '../../components/FormContainer';

const styles = () => {
	return {};
};

class SaveJourneyPlan extends FormComponent {
	constructor(props) {
		super(props);

		const action = _.get(this.props, 'match.params.action');
		const journeyPlanId = parseInt(_.get(this.props, 'match.params.journeyPlanId'), 10);
		const isUpdate = action === 'update';

		this.state = {
			isUpdate,
			journeyPlanId,
			formFieldError: {},
		};
	}

	componentDidMount() {
		const { journeyPlan, getJourneyPlan } = this.props;
		const { journeyPlanId, isUpdate } = this.state;

		if (!isUpdate) {
			return;
		}

		if (journeyPlan) {
			this.fillForm({ journeyPlan });
		} else {
			getJourneyPlan({
				params: { journeyPlanIds: [journeyPlanId] },
			});
		}
	}

	componentDidUpdate(prevProps, prevState, snapShot) {
		const { journeyPlan } = this.props;

		if (_.isUndefined(prevProps.journeyPlan) && !_.isUndefined(journeyPlan)) {
			this.fillForm({ journeyPlan });
		}
	}

	fillForm = ({ journeyPlan }) => {
		if (!journeyPlan) {
			return;
		}

		const newState = Object.keys(journeyPlan).reduce((acc, key) => {
			const value = journeyPlan[key];
			if (key === 'dateCreated' || _.isNil(value)) {
				return acc;
			}

			acc[key] = value;
			return acc;
		}, {});

		this.setState(newState);
	};

	handleSave = ({ callback }) => {
		const { addJourneyPlan, updateJourneyPlan } = this.props;
		const { isUpdate, journeyPlanId } = this.state;

		const formFieldError = {};
		_.values(this.requiredPathMap).forEach(({ path, label }) => {
			if (!this.state[path]) {
				formFieldError[path] = `${label} is required`;
			}
		});

		//- Get all the values and do individual checks
		if (_.keys(formFieldError).length) {
			this.setState({ formFieldError });
			//showErrors(_.values(formFieldError));
			return callback(_.values(formFieldError));
		}

		const { consigneeCompanyId, resourceId } = this.state;
		const params = {
			consigneeCompanyId,
			resourceId,
		};

		if (!isUpdate) {
			addJourneyPlan({
				params,
				callback,
			});
		} else {
			params.journeyPlanId = journeyPlanId;
			updateJourneyPlan({
				params,
				callback,
			});
		}
	};

	render() {
		const { isUpdate } = this.state;
		const { showErrors } = this.props;

		const action = isUpdate ? 'Update' : 'Add';
		return (
			<FormContainer headline={`${action} Journey Plan`}>
				<Grid item xs={8}>
					<Grid spacing={2} container>
						<FormText {...this.setForm('consigneeCompanyId', 'Consignee Company ID', true)} />
						<Grid item xs={12}>
							<FormFileUploader {...this.setForm('resourceId', 'Journey Plan JPG', true)} />
						</Grid>
					</Grid>

					{[].map((metaField) => {
						const { prop, label, helpText, options } = metaField;

						if (options) {
							return (
								<FormSelect
									key={prop}
									label={label}
									options={options}
									helpText={helpText}
									{...this.getInputProps(prop)}
									gridProps={{ sm: 6 }}
								/>
							);
						}

						return (
							<FormText
								key={prop}
								label={label}
								helpText={helpText}
								{...this.getInputProps(prop)}
								gridProps={{ sm: 6 }}
							/>
						);
					})}

					<FormActions
						onSave={this.handleSave}
						onCancel={this.goBackToList}
						onDone={_.noop}
						onError={showErrors}
						saveButtonText={`${action} Journey Plan`}
						saveProgressText={isUpdate ? 'Updating Journey Plan' : 'Creating New Journey Plan'}
						saveSuccessText={'Journey plan saved successfully. Thank you.'}
					/>
				</Grid>
			</FormContainer>
		);
	}
}

SaveJourneyPlan.propTypes = {
	addJourneyPlan: PropTypes.func.isRequired,
	updateJourneyPlan: PropTypes.func.isRequired,
	journeyPlan: PropTypes.object,

	showErrors: PropTypes.func.isRequired,
	classes: PropTypes.object.isRequired,
};

export default _.flow([withStyles(styles), AuthUserContainer, JourneyPlanContainer])(
	SaveJourneyPlan
);
